import type { GeneratorGeneratorSchema } from "./schema";

import { join } from "node:path";
import { formatFiles, generateFiles, type Tree } from "@nx/devkit";

import {
  createAndUpdateGeneratorsJson,
  getGeneratorInformation,
  getTemplateFilesOptions,
} from "../../utils/generators";
import { getOrDefaults } from "../../utils/helpers";

async function generatorGenerator(
  tree: Tree,
  options: GeneratorGeneratorSchema
) {
  const plugin = getOrDefaults(options.plugin, "@kcinternals/nx-plugin");
  const generator = await getGeneratorInformation(tree, {
    name: options.name,
    plugin: plugin,
  });
  console.log(JSON.stringify(generator));

  const template = join(__dirname, "files");
  const templateOptions = getTemplateFilesOptions(generator, {
    name: options.name,
    description: options.description,
    plugin: plugin,
    extra: options,
  });

  // Update generators.json file
  createAndUpdateGeneratorsJson(tree, generator);

  // Create generator files
  generateFiles(tree, template, generator.directory, templateOptions);
  const templatePath = join(generator.directory, "files/src/index.ts.template");
  tree.write(templatePath, 'const variable = "<%= name %>";');

  await formatFiles(tree);
}

export default generatorGenerator;
